import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromSoftware from './reducers/software.reducer';
import { EffectsModule } from '@ngrx/effects';
import { SoftwareEffects } from './effects/software.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('SoftwareVersion', fromSoftware.reducer),
    EffectsModule.forFeature([SoftwareEffects])
  ]
})
export class SoftwareModule { }
